import React from 'react';
import Reflux from 'reflux';
import {
    Button,
    Form,
    Row,
    Col,
    Modal,
    Input,
    message,
    Select,
    DatePicker,
    InputNumber,
    Tooltip, Checkbox
} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice} from 'Utils';
import {
    getPro,
    getProByItems,
    create,
    getSubStoreList,
    detail,
    getHistoryPrice,
    listSecondList
} from '../../service/thingsOrder';
import {
    firstChannelListByPage, // 获取发货仓库
} from '../../service/order';
import './corder.css';
import moment from 'moment';
import {getStockList} from "../../service/product";
import result from "../survey/result";

const confirm = Modal.confirm;
const {TextArea} = Input;

class CustomOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.state = {
            button_limits_end: {},
            opts: ['新增销售单'],
            subDisabled: false,
            key: 0,
            visible: false,
            addRows: [],
            addTotal: 1,
            selectedRowsAll: {},
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
            amount: 0, //总额
            actualAmount: 0, //实收金额
            name: '',
            code: '',
            sfts: '',
            showPrice: '',
            caozuoyuan: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            businessName: '',
            ids: [],
            discountRate: 100, //订单整体折扣率
            disActualAmount: 0, //整单折扣后实收金额
            storeId: '',
            customerId: '',
            sortName: '',
            orderType: this.userData.second ? '2' : JSON.parse(window.localStorage.getItem('login_user_information')).orderType ? JSON.parse(window.localStorage.getItem('login_user_information')).orderType.toString() : '',
            remarkData: '',
            remark: '',
            getMoneyTypeData: JSON.parse(window.localStorage.getItem('login_user_information')).payType ? JSON.parse(window.localStorage.getItem('login_user_information')).payType : '',
            orderDate: '',
            customerInDate: '',
            price: '',
            list2Data: [],
            subStoreList: [],
            count: '',
            priceRate: '',
            addLoading: false,
            addSearchObj: {
                s: 10,
                p: 1
            },
            submitRows: [],
            submitRows1: [],
            rows: [],
            total: 1,
            kcsp_checked: false,
            changeSearch: false,
            quickVisible: false,
            quickLoading: false,
            quickString: '',
            quickResult: [],
            searchObj: {
                s: 10,
                p: 1
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            amountDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).amountDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).amountDecimalPlace : 2,
            priceDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).priceDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).priceDecimalPlace : 4,
            countDecimalPlace: JSON.parse(window.localStorage.getItem('login_user_information')).countDecimalPlace != null ? JSON.parse(window.localStorage.getItem('login_user_information')).countDecimalPlace : 2,
            orderMultiLine: JSON.parse(window.localStorage.getItem('login_user_information')).orderMultiLine != null ? JSON.parse(window.localStorage.getItem('login_user_information')).orderMultiLine : 0,
            sortRules: JSON.parse(window.localStorage.getItem('login_user_information')).sortRules
        }
    };


    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    goBack() {
        hashHistory.goBack();
    }

    /*选择外层列表*/
    onOutsideSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    }
    /*外层翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.initData();
        });
    }
    /*选择物料弹窗*/
    searchHandler = () => {
        if (!this.state.storeId || this.state.storeId == '') {
            openNotice('warning', '请先选择子库存', '');
            return
        }
        if (!this.userData.second && (!this.state.customerId || this.state.customerId == '')) {
            openNotice('warning', '请先选择客户', '');
            return
        }
        //this.getAddArray();
        this.setState({visible: true, showPrice: '', price: ''});
    }
    deletedFn = () => {
        const {submitRows, selectedRowKeysOutside} = this.state;
        if (selectedRowKeysOutside.length == 0) {
            openNotice('warning', '请选择删除数据', '');
            return;
        }
        const arr = submitRows.filter(item => !selectedRowKeysOutside.includes(item.id));
        const selected = [];
        arr.forEach(item => {
            selected.push(item.id)
        });
        this.setState({
            submitRows: arr,
            selectedRowsAllKeys: [...selected],
        }, () => {
            this.confirmAmount();
        });
    }
    /*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        const {selectedRowsAll, addSearchObj} = this.state;
        selectedRowsAll[addSearchObj.p] = selectedRows;
        this.setState({
            selectedRowsAll: selectedRowsAll,
            selectedRowKeys: selectedRowKeys
        });
    };
    /*选择物料列表翻页*/
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, () => {
            this.getAddArray();
        });
    };

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value,
            changeSearch: true
        });
    };
    sftsChange = (value) => {
        this.setState({
            sfts: value,
            changeSearch: true
        });
    };
    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value,
            changeSearch: true
        });
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.getAddArray();
        }
    };
    /*选择物料列表数据(点击搜索)*/
    getAddArray = () => {
        if (this.state.code == '' && this.state.name == '') {
            openNotice('warning', '请先输入需要搜索的物料', '');
            return
        }

        const searchObj = {
            code: this.state.code,
            name: this.state.name,
            p: this.state.changeSearch ? 1 : this.state.addSearchObj.p,
            s: this.state.addSearchObj.s,
            substoreId: this.state.storeId || '',
            secondCustId: this.state.customerId || '',
            kcspChecked: this.state.kcsp_checked,
            sortRules: this.state.sortRules,
            sfts: this.state.sfts
        };
        this.setState({addLoading: true});
        getPro(searchObj).then(result => {
            if (result.status && result.code == 200) {
                const data = result.data || [];
                data.forEach(item => {
                    item.priceRate = null;
                    item.price = null;
                })
                this.setState({
                    addRows: data,
                    addTotal: result.total,
                    changeSearch: false,
                    addSearchObj: searchObj,
                    addLoading: false
                });
            } else {
                this.setState({addLoading: false});
                message.error(result.message);
            }
        }).catch(() => {
            this.setState({addLoading: false});
            message.error('物料搜索失败');
        });
    };

    confirmAmount2() {
        let submitRows = this.state.submitRows;
        let amount = 0;
        let actualAmount = 0;
        submitRows.map(item => {
            amount += (item.showPrice || 0) * (item.count || 0);
            actualAmount += (item.price || 0) * (item.count || 0);
            this.setState({
                amount,
                actualAmount,
                disActualAmount: (Math.floor(actualAmount * this.state.discountRate) / 100).toFixed(this.state.amountDecimalPlace)
            });
        })
    }

    //数量
    viewCountChange = (record, val) => {
        const {submitRows} = this.state;
        let amount = 0;
        let actualAmount = 0;
        let arr = submitRows.map(item => {
            if (item.id === record.id) {
                item.count = val || 0;
                item.price = item.price || 0;
                record.priceRate = Math.round((1 - (record.price / record.showPrice)) * 10000) / 100;
            }
            amount += (item.showPrice || 0) * (item.count || 0);
            actualAmount += (item.price || 0) * (item.count || 0);
            return item;
        })
        this.setState({
            amount,
            actualAmount,
            submitRows: arr,
            disActualAmount: (Math.floor(actualAmount * this.state.discountRate) / 100).toFixed(this.state.amountDecimalPlace)
        });
        // record.count = this.decimalPlace(val, this.state.countDecimalPlace);
        // if (!record.price) {
        //     record.price = 0;
        // }
        // this.confirmAmount(record.price, record.count);
        // this.setState({count: record.count, showPrice: record.showPrice});
        //
        // if (!record.count) {
        //     record.count = 0;
        // }
        // record.priceRate = Math.round((1 - (record.price / record.showPrice)) * 10000) / 100;
        // this.setState({priceRate: record.priceRate, price: record.price}, () => {
        //     this.confirmAmount(record.price, record.count);
        // });
    };

    addCountChange = (record, e) => {
        record.num = e.target.value;
        if (record.originalPrice != null && record.priceRate == null) {
            record.priceRate = Math.round((1 - (record.originalPrice / record.showPrice)) * 10000) / 100;
        }
        if (record.price == null) {
            record.price = record.originalPrice
        }
        this.setState({num: e.target.value});

    };

    addRateChange = (record, e) => {
        record.priceRate = e.target.value;
        record.price = ((1 - (record.priceRate / 100)) * record.showPrice).toFixed(this.state.priceDecimalPlace);
        this.setState({priceRate: e.target.value});
    };

    changePrice = (record, e) => {
        /*if (e.target.value > record.showPrice || e.target.value < 0) {
            return
        }*/
        record.price = this.decimalPlace(e.target.value, this.state.priceDecimalPlace);
        if (!record.count) {
            record.count = 0;
        }
        if (record.showPrice == 0) {
            record.priceRate = 0;
        } else {
            record.priceRate = Math.round((1 - (record.price / record.showPrice)) * 10000) / 100;
        }
        this.setState({priceRate: record.priceRate, price: record.price}, () => {
            this.confirmAmount(record.price, record.count);
        });
    };

    changLineRemark = (record, e) => {
        record.remark = e.target.value;
        this.setState({remark: record.remark});
    }

//下浮率
    priceRateFn = (record, e) => {
        /*if (e.target.value > 100 || e.target.value < 0) {
            return
        }*/
        record.priceRate = this.decimalPlace(e.target.value, 2);
        if (!record.count) {
            record.count = 0;
        }
        record.price = ((1 - (e.target.value / 100)) * record.showPrice).toFixed(this.state.priceDecimalPlace);
        // this.state.actualAmount = (this.state.actualAmount + this.state.count * (record.showPrice - record.price));
        this.setState({priceRate: e.target.value, price: record.price}, () => {
            this.confirmAmount(record.price, record.count);
        });
    }

    //小数位过滤
    decimalPlace = (value, fix) => {
        if (fix == 0) {
            return (value.match(/^\d*(\.?\d{0,0})/g)[0]) || null;
        } else if (fix == 1) {
            return (value.match(/^\d*(\.?\d{0,1})/g)[0]) || null;
        } else if (fix == 2) {
            return (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null;
        } else if (fix == 3) {
            return (value.match(/^\d*(\.?\d{0,3})/g)[0]) || null;
        } else if (fix == 4) {
            return (value.match(/^\d*(\.?\d{0,4})/g)[0]) || null;
        } else if (fix == 5) {
            return (value.match(/^\d*(\.?\d{0,5})/g)[0]) || null;
        } else if (fix == 6) {
            return (value.match(/^\d*(\.?\d{0,6})/g)[0]) || null;
        }
    }

//计算金额
    confirmAmount() {
        let submitRows = this.state.submitRows;
        let amount = 0;
        let actualAmount = 0;
        if (submitRows.length == 0) {
            this.setState({
                amount,
                actualAmount,
                disActualAmount: 0
            });
        } else {
            submitRows.map(item => {
                amount += (item.showPrice || 0) * (item.count || 0);
                actualAmount += (item.price || 0) * (item.count || 0);
                this.setState({
                    amount,
                    actualAmount,
                    disActualAmount: (Math.floor(actualAmount * this.state.discountRate) / 100).toFixed(this.state.amountDecimalPlace)
                });
            })
        }
    }

    confirmAmount1() {
        let submitRows = this.state.submitRows;
        let amount = 0;
        let actualAmount = 0;
        if (submitRows.length == 0) {
            this.setState({
                amount,
                actualAmount,
                disActualAmount: 0
            });
        } else {
            submitRows.map(item => {
                if (item.refresh) {
                    item.price = ((1 - (item.priceRate / 100)) * item.showPrice).toFixed(this.state.priceDecimalPlace);
                }
                amount += (item.showPrice || 0) * (item.count || 0);
                actualAmount += (item.price || 0) * (item.count || 0);
                this.setState({
                    amount,
                    actualAmount,
                    submitRows,
                    disActualAmount: (Math.floor(actualAmount * this.state.discountRate) / 100).toFixed(this.state.amountDecimalPlace)
                });
            })
        }
    }

    caozuoChange = (e) => {
        this.setState({caozuoyuan: e.target.value});
    }
//整体折扣率
    countChange = (e) => {
        // if (e.target.value > 100) {
        //     return;
        // }
        let value = this.decimalPlace(e.target.value, 6);
        this.setState({
            discountRate: value,
            disActualAmount: (this.state.actualAmount * value / 100).toFixed(this.state.amountDecimalPlace)
        });
    }
    disActualAmountChange = (e) => {
        /*if (e.target.value > this.state.actualAmount) {
            return;
        }*/
        let value = this.decimalPlace(e.target.value, this.state.amountDecimalPlace);
        this.setState({
            disActualAmount: value,
            discountRate: (value / this.state.actualAmount * 100).toFixed(6)
        });
    }
    remarkChange = (e) => {
        this.setState({remarkData: e.target.value});
    }

    businessChange = (e) => {
        this.setState({businessName: e.target.value});
    }
//子库存id
    storeChange = (value) => {
        /*confirm({
            content: '切换子库存将重置订单商品,确定吗?',
            onOk() {
                self.setState({
                    submitRows: [],
                    amount: 0,
                    actualAmount: 0,
                });
            },
            onCancel() {
                return
            }
        })*/
        this.setState({storeId: value});
    }
    storeSelect = (value) => {
        const self = this;
        let rows = [...self.state.submitRows];
        if (this.state.storeId && this.state.storeId != '') {
            for (let i = 0; i < self.state.submitRows.length; i++) {
                getStockList({
                    'name': self.state.submitRows[i].code,
                    'subStoreId': value,
                    'p': 1,
                    's': 10
                }).then(result => {
                    if (result && result.code == 200) {
                        if (result.data.length > 0) {
                            rows[i].currentNum = result.data[0].count
                        } else {
                            rows[i].currentNum = 0
                        }
                        self.setState({submitRows: rows});
                    }
                })
            }
            for (let i = 0; i < self.state.submitRows.length; i++) {
                getHistoryPrice({
                    'id': self.state.submitRows[i].id,
                    'type': self.state.submitRows[i].type || self.state.submitRows[i].productType,
                    'secondCustId': self.state.customerId,
                    'substoreId': value,
                    'p': 1,
                    's': 10
                }).then(result => {
                    if (result && result.code == 200) {
                        if (result.data.length > 0) {
                            rows[i].originalPrice = result.data[0].originalPrice
                        } else {
                            rows[i].originalPrice = ''
                        }
                        self.setState({submitRows: rows});
                    }
                })
            }
        }
        this.setState({storeId: value});
    }
//客户id
    customerChange = (value) => {
        const self = this;
        let rows = [...self.state.submitRows];
        if (this.state.customerId && this.state.customerId != '') {
            /*confirm({
                content: '切换客户名称将重置订单商品,确定吗?',
                onOk() {
                    self.setState({
                        submitRows: [],
                        amount: 0,
                        actualAmount: 0,
                    });
                },
                onCancel() {
                    return
                }
            })*/
            for (let i = 0; i < self.state.submitRows.length; i++) {
                getHistoryPrice({
                    'id': self.state.submitRows[i].id,
                    'type': self.state.submitRows[i].type || self.state.submitRows[i].productType,
                    'secondCustId': value,
                    'substoreId': self.state.storeId,
                    'p': 1,
                    's': 10
                }).then(result => {
                    if (result && result.code == 200) {
                        if (result.data.length > 0) {
                            rows[i].originalPrice = result.data[0].originalPrice
                        } else {
                            rows[i].originalPrice = ''
                        }
                        self.setState({submitRows: rows});
                    }
                })
            }
        }
        this.setState({customerId: value});
    }
    /*客户缩写*/
    shortNameChange = (value) => {
        const self = this;
        if (this.state.sortName && this.state.sortName != '') {
            /*self.setState({
                submitRows: [],
                amount: 0,
                actualAmount: 0,

            });*/
            // },
            /*onCancel() {
                return
            }*/
            // })
        }
        this.setState({sortName: value});
    }
//订单类型
    orderTypeChange = (value) => {
        const self = this;

        if (this.state.customerId && this.state.customerId != '') {
            confirm({
                content: '切换订单类型将重置客户名称、客户缩写，确定吗?',
                onOk() {
                    /*self.setState({
                        submitRows: [],
                        amount: 0,
                        actualAmount: 0,
                    });*/
                    //这里是通过订单类型筛选客户名称下拉框选项的逻辑判断
                    if (value === '1') {
                        self.getList2({p: 1, s: 10000, removeFlag: "0", status: "1"});
                    }
                    if (value === '2') {
                        self.getList2({cusType: 'SALES_CUS', p: 1, s: 10000, removeFlag: "0", status: "1"});
                    }
                    if (value === '3') {
                        self.getList2({p: 1, s: 10000, removeFlag: "0", status: "1"});
                    }
                    self.setState({orderType: value, customerId: '', sortName: ''});
                },
                onCancel() {
                    return
                }
            })
        } else {
            if (value === '1') {
                self.getList2({p: 1, s: 10000, removeFlag: "0", status: "1"});
            }
            if (value === '2') {
                self.getList2({cusType: 'SALES_CUS', p: 1, s: 10000, removeFlag: "0", status: "1"});
            }
            if (value === '3') {
                self.getList2({p: 1, s: 10000, removeFlag: "0", status: "1"});
            }
            self.setState({orderType: value, customerId: '', sortName: ''});
        }
    }
    getMoneyType = (value) => {
        this.setState({getMoneyTypeData: value});
    }
    dateOnChange = (date, dateString) => {
        if (date) {
            this.setState({orderDate: dateString});
        }
    }
    /*点击保存提交数据*/
    createHandler2 = () => {
        const self = this;
        if (this.userData.second) {
            Modal.confirm({
                title: 'Do you Want to delete these items?',
                content: 'Some descriptions',
                cancelText: '仅保存',
                okText: '保存并提交',
                onOk() {
                    self.createHandler();
                },
                onCancel() {
                    self.createHandler();
                },
            });
        } else {
            this.createHandler()
        }
    }
    createHandler = () => {
        var self = this;
        self.setState({subDisabled: true});
        let arr = [];
        let id = this.props.params.id;
        const len = this.state.submitRows.length;

        if (this.state.discountRate == '') {
            openNotice('error', '请填写整单折扣', '');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.getMoneyTypeData == '') {
            openNotice('error', '请选择付款方式', '');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.orderType == '') {
            openNotice('error', '请选择订单类型', '');
            self.setState({subDisabled: false});
            return;
        }
        if (!this.userData.second && this.state.customerId == '') {
            openNotice('error', '请选择客户名称', '');
            self.setState({subDisabled: false});
            return;
        }
        if (len === 0) {
            openNotice('error', '请添加产品', '');
            self.setState({subDisabled: false});
            return;
        }
        this.state.submitRows.forEach(item => {
            arr.push({
                productId: (item.productId) + '',
                priceRate: item.priceRate + '',
                count: item.count + '',
                unitPrice: item.price,
                sumPrice: (item.showPrice * item.count) + '',
                currentPrice: item.showPrice,
                productType: item.type || item.productType,
                remark: item.remark,
                unit: item.unit,
                originalPrice: item.originalPrice
            });

        });
        arr.reverse();
        const flag = arr.every(function (val, index, arr) {
            return (val.count > 0 && val.unitPrice != null);
        });

        if (!flag) {
            openNotice('error', '请输入下浮率和数量！');
            self.setState({subDisabled: false});
            return;
        }
        var createObj = {
            "amount": self.state.amount,
            "cusId": self.state.customerId || self.userData.empId,
            "sortName": self.state.sortName,
            "discountRate": self.state.discountRate,
            "operateName": self.state.caozuoyuan,
            "businessName": self.state.businessName,
            "orderDate": (self.state.orderDate || moment(new Date()).format('YYYY-MM-DD HH:mm:SS')),
            "orderType": self.state.orderType,
            "disCountAmount": (self.state.amount - self.state.actualAmount),
            "payType": self.state.getMoneyTypeData,
            "productList": arr,
            "receivedAmount": self.state.actualAmount,
            "remark": self.state.remarkData,
            "storageId": this.state.storeId,
        };
        if (id) {
            createObj.id = id;
        }
        create(createObj).then(result => {
            if (result.status && result.code == 200) {
                openNotice('success', '保存成功', '');
                const data = result.data;
                self.goView('thingsOrder/' + data.id);
            } else {
                openNotice('error', '保存失败', result.message || '');
                self.setState({subDisabled: false});
            }
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        this.getList2({p: 1, s: 10000, removeFlag: "0", status: "1"});
        if (this.userData.second) {
            firstChannelListByPage().then(res => {
                this.setState({subStoreList: res.data || []});
            });
        } else {
            getSubStoreList({
                removeFlag: 0,
                s: 10000,
                p: 1,
            }).then((result) => { //获取子库存
                if (result && result.code == 200) {
                    self.setState({subStoreList: result.data}, () => {
                        result.data.forEach(item => {
                            if (item.masterStore == 'Y') {
                                self.setState({storeId: item.id.toString()});
                            }
                        })
                    });
                } else {
                    openNotice('error', '获取数据失败', result.message || '');
                }
            });
        }
    }

    getList2(param) {
        listSecondList(param).then((result) => { //获取客户管理
            if (result && result.code == 200) {
                this.setState({list2Data: result.data});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

//离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    };

    componentWillMount() {
        window.myTemp = 1;
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }
    ;

    componentDidMount() {
        let id = this.props.params.id;
        this.initData();
        var allRows = 0;
        var finshRows = 0;
        const items = [];
        if (id) {
            this.setState({subDisabled: true});
            detail(id).then(res => {
                if (res.code === 200) {
                    const data = res.data || {};
                    (data.productList || []).forEach(item => {
                        item.showPrice = item.currentPrice;
                        item.price = item.unitPrice;
                        item.id = window.myTemp++;
                        allRows++;
                        items.push(item.code);
                    });

                    let tmp = {
                        orderDate: data.orderDate,
                        orderType: data.orderType + '',
                        getMoneyTypeData: data.payType,
                        storeId: data.storageId ? (data.storageId + '') : '',
                        customerId: data.cusId + '',
                        sortName: data.cusShortname + '',
                        remarkData: data.remark,
                        businessName: data.businessName,
                        discountRate: data.discountRate,
                        disActualAmount: (Math.round(data.discountRate * data.discountRate) / 100).toFixed(this.state.amountDecimalPlace),
                        submitRows: data.productList || [],
                    }
                    if (data.createFlag === 2) {
                        tmp.list2Data = [{name: data.cusName, id: `${data.cusId}`}]
                    }
                    this.setState({
                        ...tmp,
                    }, () => {
                        this.confirmAmount();
                    });
                    const submitRows = this.state.submitRows;

                    if (data.orderDate >= moment().format('YYYY-MM-DD')) {

                        /* (submitRows || []).forEach(item => {
                             const searchObj = {
                                 code: item.code,
                                 p: 1,
                                 s: 1
                             };
                             getPro(searchObj).then(result => {
                                 if (result.status && result.code == 200) {
                                     finshRows++;
                                     if (finshRows == allRows) {
                                         this.setState({subDisabled: false})
                                     }
                                     const data = result.data || [];
                                     data.forEach(itm => {
                                         if (item.showPrice == itm.showPrice) {
                                             item.refresh = false;
                                         } else {
                                             item.refresh = true;
                                             item.showPrice = itm.showPrice;
                                         }
                                     })
                                     this.setState({submitRows: submitRows}, () => {
                                         this.confirmAmount1();
                                     });
                                 } else {
                                     message.error(result.message);
                                 }
                             })
                         });*/

                        const searchObj = {
                            items: items,
                            p: 1,
                            s: 9999
                        }

                        getProByItems(searchObj).then(result => {
                            if (result.status && result.code == 200) {
                                const data = result.data || [];
                                (submitRows || []).forEach(row => {
                                    //默认不刷新
                                    row.refresh = false;
                                    data.forEach(itm => {
                                        if (row.code == itm.code) {
                                            if (row.showPrice != itm.showPrice) {
                                                row.refresh = true;
                                                row.showPrice = itm.showPrice;
                                            }
                                        }
                                    })
                                })
                                this.setState({submitRows: submitRows}, () => {
                                    this.confirmAmount1();
                                    this.setState({subDisabled: false});
                                });
                            } else {
                                message.error(result.message);
                            }
                        });

                    } else {
                        this.setState({subDisabled: false})
                    }
                }
            });
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        console.log(this.state);
    }

    handleOk = () => {
        const self = this;
        const {selectedRowsAll} = this.state;
        var arr = Object.values(selectedRowsAll).reduce((prev, current) => prev.concat(current), []);
        const selected = [];
        arr.forEach(item => {
            selected.push(item.id);
        });
        // var arrNew = [...arr];
        // for (let t = 0; t < arr.length; t++) {
        //     getXiaFu({
        //         "cusId": self.state.customerId,
        //         "proId": arrNew[t].id,
        //         "proType": arrNew[t].type
        //     }).then(res => {
        //         // debugger
        //         // console.log(arrNew);
        //         arrNew[t] = {
        //             ...arr[t],
        //             priceRate: res.data.priceRate,
        //             price: (100 - res.data.priceRate) * arrNew[t].showPrice / 100,
        //         };
        //         self.setState({submitRows: [...this.state.submitRows, arrNew[t]]})
        //     })
        // }
        self.setState({
            // submitRows: [...this.state.submitRows, ...arrNew],
            selectedRowsAllKeys: [...this.state.selectedRowsAllKeys, ...selected],
            selectedRowKeys: [],
            selectedRowKeysOutside: [],
        });
        self.handleCancel()
    };
    handleCancel = () => {
        this.setState({
            name: '',
            code: '',
            visible: false
        });
    };

    goView(url) {
        hashHistory.push(url);
    }

    quickHandler = (event) => {
        this.setState({quickVisible: true});
    };

    handleCancel6 = () => {
        this.setState({quickVisible: false});
    };

    quickChange = (event) => {
        this.setState({
            quickString: event.target.value,
        });
    };

    kcspChange = (e) => {
        this.setState({
            kcsp_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1},
        });
    };

    addSave(record) {
        const self = this;
        const {selectedRowsAllKeys, submitRows, selectedRowKeys, selectedRowsAll, searchObj} = this.state;


        let record1 = {...record};

        record1.productId = record1.id;
        record1.id = window.myTemp++;

        record1.count = record1.num;

        let rows = [];
        submitRows.forEach(item => {
            rows.push(item.productId);
        })

        if (rows.includes(record1.productId) && self.state.orderMultiLine == 0) {
            const addQtyRaw = record1.num;
            const hasQty = addQtyRaw !== undefined && addQtyRaw !== null && String(addQtyRaw).trim() !== '';
            if (!hasQty) {
                openNotice('warning', '商品已添加');
                return;
            }
            Modal.confirm({
                title: '提示',
                content: '已存在物料，是否累加数量？',
                okText: '是',
                cancelText: '否',
                onOk: () => {
                    let accumulated = false;
                    const nextRows = self.state.submitRows.map(item => {
                        if (!accumulated && item.productId === record1.productId) {
                            accumulated = true;
                            const oldQty = (item.count === '' || item.count == null) ? 0 : Number(item.count);
                            const addQty = Number(addQtyRaw);
                            return {
                                ...item,
                                count: (isNaN(oldQty) ? 0 : oldQty) + (isNaN(addQty) ? 0 : addQty)
                            };
                        }
                        return item;
                    });
                    self.setState({submitRows: nextRows}, () => {
                        self.confirmAmount();
                    });
                    openNotice('success', '数量已累加');
                }
            });
            return;
        }

        const arr1 = selectedRowKeys.filter(item => item !== record1.id);
        let arr2 = [];
        if (selectedRowsAll[searchObj.p]) {
            arr2 = selectedRowsAll[searchObj.p].filter(item => item.id !== record1.id);
        }
        selectedRowsAll[searchObj.p] = arr2;
        //获取下浮

        // getXiaFu({
        //     "cusId": self.userData.second ? self.userData.empId : self.state.customerId,
        //     "proId": record.id,
        //     "proType": record.type
        // }).then(res => {
        //     if (self.userData.second) {
        //         record1.priceRate = 100;
        //         record1.price = 0;
        //     } else {
        //         record1.priceRate = res.data.priceRate;
        //         record1.price = (100 - res.data.priceRate) * ((record.originalPrice != '' && record.originalPrice != null) ? record.originalPrice : record.showPrice) / 100;
        //     }
        // })
        this.setState({
            selectedRowKeys: [...arr1],
            selectedRowsAllKeys: [...selectedRowsAllKeys, record1.id],
            selectedRowsAll: {...selectedRowsAll},
            submitRows: [...submitRows, record1]
        }, () => {
            let {amount, actualAmount} = this.state;
            amount += (record1.showPrice || 0) * (record1.count || 0);
            actualAmount += (record.price != null ? record.price : record.showPrice || 0) * (record1.count || 0);

            this.setState({
                amount: amount,
                actualAmount: actualAmount,
                disActualAmount: (Math.floor(actualAmount * this.state.discountRate) / 100).toFixed(this.state.amountDecimalPlace)
            });

        })
        openNotice('success', '商品添加成功');
    }

    handleOk6 = () => {
        if (this.state.quickString.length == 0) {
            this.setState({quickVisible: false, quickLoading: false, quickString: ''});
            return;
        }
        var rowcount = 0;
        var finshcount = 0;
        this.setState({quickLoading: true, quickResult: []});
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                rowcount++;
            }
        });
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                var searchItem;
                var count = null;
                if (item.trim().indexOf(',') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(','));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(',') + 1))) {
                        count = item.trim().substr(item.trim().indexOf(',') + 1);
                    }
                } else {
                    searchItem = item.trim();
                }
                getPro({
                    code: searchItem,
                    p: 1,
                    s: 1,
                    substoreId: this.state.storeId || '',
                    secondCustId: this.state.customerId || ''
                }).then(result => {
                    finshcount++;
                    if (result.status && result.code == 200) {
                        if (result.total > 0) {
                            result.data.forEach(item => {
                                item.num = count;
                            })
                            const quickResult = this.state.quickResult;
                            quickResult.push(result.data[0]);
                        }
                    } else {
                        message.error(result.message);
                        this.setState({quickLoading: false});
                    }
                    if (rowcount == finshcount) {

                        this.state.quickString.split(/[\n]/).forEach(item => {
                            if (item.trim().length > 0) {
                                const quickResult = this.state.quickResult;
                                quickResult.forEach(item2 => {
                                    var searchItem;
                                    if (item.trim().indexOf(',') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(','));
                                    } else {
                                        searchItem = item.trim();
                                    }
                                    if (item2.code == searchItem) {
                                        this.addSave(item2, null, null);
                                    }
                                })
                            }
                        });

                        this.setState({quickVisible: false, quickLoading: false, quickString: '', quickResult: []});
                    }
                });


            }
        });
    };

    render() {
        var self = this;
        const {
            opts,
            key,
            total,
            searchObj,
            selectedRowKeys,
            showPrice,
            price,
            selectedRowKeysOutside,
            count,
            list2Data,
            subStoreList,
            visible,
            storeId,
            customerId,
            actualAmount,
            amount,
            orderDate,
            discountRate,
            remarkData,
            caozuoyuan,
            businessName,
            orderType,
            getMoneyTypeData,
            addRows,
            addTotal,
            addSearchObj,
            addLoading,
            button_limits_end,
            remark,
            disActualAmount,
            sortName,
            quickVisible,
            quickLoading,
            quickString,
            kcsp_checked,
            subDisabled
        } = this.state;
        // const {getFieldDecorator} = this.props.form;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '序号',
                    width: 50,
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return index + 1;
                    },
                }, {
                    title: '物料编码',
                    dataIndex: 'code'
                },
                {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: '200px'
                },
                {
                    title: '物料类别',
                    dataIndex: 'proType'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '现有量',
                    dataIndex: 'currentNum'
                },
                {
                    title: <Tooltip
                        title='不包含本订单的产品数量，统计【已登记未发货的数量】，同时扣减【已登记未退货入库的数量】。遇到未出库数量不准时，请核查历史【已登记】的订单'>未出库</Tooltip>,
                    dataIndex: 'unShipCount'
                },
                {
                    title: '历史价',
                    dataIndex: 'originalPrice'
                },
                {
                    title: '面价',
                    dataIndex: 'showPrice'
                },
                {
                    title: '下浮(%)',
                    dataIndex: 'priceRate',
                    render: (text, record, index) => {
                        return <Input style={{width: '80px'}} type='number' min={0} value={record.priceRate}
                                      readOnly={this.userData.second}
                                      onChange={this.priceRateFn.bind(this, record)}/>
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        /*return <Input style={{width: '80px'}} type='number' min={0} value={record.count}
                                      precision={this.state.countDecimalPlace}
                                      step={1 / Math.pow(10, this.state.countDecimalPlace)}
                                      onChange={this.viewCountChange.bind(this, record)}/>*/
                        return <InputNumber style={{width: '80px'}} type='number' min={0} value={record.count}
                                            step={record.packageQuantity || 1}
                                            onChange={(val) => this.viewCountChange(record, val)}/>
                    }
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        return <Input style={{width: '100px'}} type='number' min={0} max={record.showPrice}
                                      precision={this.state.priceDecimalPlace}
                                      step={1 / Math.pow(10, this.state.priceDecimalPlace)}
                                      value={record.price}
                                      readOnly={this.userData.second}
                                      onChange={this.changePrice.bind(this, record)}/>
                    }
                },
                {
                    title: '销售金额',
                    dataIndex: 'sumPrice',
                    render: (text, record, index) => {
                        return <Input style={{width: '100px'}} type='number' readOnly
                                      value={(record.price * record.count).toFixed(this.state.amountDecimalPlace)}/>
                    }
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => {
                        return <Input style={{width: '80px'}} type='string' value={record.remark}
                                      onChange={this.changLineRemark.bind(this, record)}/>
                    }
                },

            ],
            rows: this.state.submitRows,
            rowSelection: {selectedRowKeys: selectedRowKeysOutside, onChange: self.onOutsideSelectChange}
        };
        const addProps = {
            rowKey: 'id',
            loading: addLoading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 110,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: '300px'
                }, {
                    title: '供应商',
                    dataIndex: 'supplier',

                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',

                }, {
                    title: '内盒数',
                    dataIndex: 'minPackageQuantity',

                }, {
                    title: '面价',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>
                }, {
                    title: '历史价',
                    dataIndex: 'originalPrice',

                }, {
                    title: '现有量',
                    dataIndex: 'count',
                },
                {
                    title: <Tooltip
                        title='不包含本订单的产品数量，统计【已登记未发货的数量】，同时扣减【已登记未退货入库的数量】。遇到未出库数量不准时，请核查历史【已登记】的订单'>未出库</Tooltip>,
                    dataIndex: 'unShipCount'
                },
                {
                    title: '状态',
                    dataIndex: 'takeEffect',
                    render: text => <span>{text == 'Y' ? '有效' : '停产'}</span>
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                },
                {
                    title: '数量',
                    dataIndex: 'num',
                    render: (text, record, index) => {
                        return <Input style={{width: '80px'}} type='number' min={0} value={record.num}
                                      onChange={this.addCountChange.bind(this, record)}/>
                    }
                },
                {
                    title: '下浮(%)',
                    dataIndex: 'priceRate',
                    render: (text, record, index) => {
                        return <Input style={{width: '80px'}} type='number' value={record.priceRate}
                                      onChange={this.addRateChange.bind(this, record)}/>
                    }
                }
            ],
            rows: addRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                getCheckboxProps: record => ({
                    disabled: this.state.selectedRowsAllKeys.includes(record.id)
                })
            }*/
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button style={{marginLeft: 10}} onClick={this.createHandler}
                        disabled={subDisabled}>保存</Button>
                <Button onClick={this.goBack}>取消</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Form layout="horizontal">
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">订单日期：</label>
                            <DatePicker style={{width: 220}} onChange={this.dateOnChange}
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        value={orderDate ? moment(new Date(orderDate)) : moment(new Date())}/>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">订单类型：</label>
                            {this.userData.second &&
                                <Select style={{width: 220}} value={orderType}
                                        onChange={this.orderTypeChange}
                                >
                                    <Select.Option value='2'>零售单</Select.Option>
                                </Select>}
                            {!this.userData.second &&
                                <Select style={{width: 220}} value={orderType}
                                        onChange={this.orderTypeChange}
                                >
                                    <Select.Option value='1'>销售出库</Select.Option>
                                    <Select.Option value='2'>零售单</Select.Option>
                                    <Select.Option value='3'>退货单</Select.Option>
                                </Select>}

                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">收款方式：</label>
                            <Select style={{width: 220}}
                                    value={getMoneyTypeData}
                                    onChange={this.getMoneyType}
                            >
                                <Select.Option value='现金'>现金</Select.Option>
                                <Select.Option value='欠款'>欠款</Select.Option>
                                <Select.Option value='代收'>代收</Select.Option>
                                <Select.Option value='月结'>月结</Select.Option>
                                <Select.Option value='银行'>银行</Select.Option>
                                <Select.Option value='转账'>转账</Select.Option>
                                <Select.Option value='支付宝'>支付宝</Select.Option>
                                <Select.Option value='微信'>微信</Select.Option>
                            </Select>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">子库存：</label>
                            <Select style={{width: 220}}
                                    value={storeId}
                                    onChange={this.storeChange.bind(this)}
                                    onSelect={this.storeSelect.bind(this)}
                            >
                                {
                                    subStoreList.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.subStoreName}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    {!this.userData.second && <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">客户名称：</label>
                            <Select
                                showSearch
                                dropdownMatchSelectWidth={false}
                                optionFilterProp="children"
                                value={customerId + ''}
                                style={{width: 350}}
                                onSelect={this.customerChange.bind(this)}
                                onChange={this.shortNameChange}
                            >
                                {
                                    list2Data.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.name}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label className="ant-form-item-required">客户缩写：</label>
                            <Select
                                showSearch
                                dropdownMatchSelectWidth={false}
                                optionFilterProp="children"
                                value={sortName + ''}
                                style={{width: 220}}
                                onSelect={this.shortNameChange.bind(this)}
                                onChange={this.customerChange}
                            >
                                {
                                    list2Data.map(function (item) {
                                        return <Select.Option key={item.id}
                                                              value={item.id + ''}>{item.sortName + '  ' + item.name}</Select.Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>}
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label>操作员：</label>
                            <Input value={caozuoyuan} style={{width: 220}} onChange={this.caozuoChange}/>
                        </Col>
                        <Col span={12} style={{marginTop: 10}}>
                            <label>备注：</label>
                            <TextArea value={remarkData} style={{width: 250}} onChange={this.remarkChange}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12} style={{marginTop: 10}}>
                            <label>销售员：</label>
                            <Input value={businessName} style={{width: 220}} onChange={this.businessChange}/>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        {button_limits_end.thingsOrder_add_05 && <Button onClick={this.searchHandler}>新增</Button>}
                        {button_limits_end.thingsOrder_add_06 &&
                            <Button onClick={this.deletedFn} style={{marginLeft: 10}}>删除</Button>}
                        {button_limits_end.thingsOrder_add_05 &&
                            <Button style={{marginLeft: 30}}
                                    onClick={this.quickHandler}>快捷录入</Button>}
                    </div>
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">面价总额：￥{amount.toFixed(this.state.amountDecimalPlace)}</span></p>
                        <p><span
                            className="right">优惠金额：￥{(amount - actualAmount).toFixed(this.state.amountDecimalPlace)}</span>
                        </p>
                        <p><span
                            className="right">销售总额：￥{actualAmount.toFixed(this.state.amountDecimalPlace)}</span>
                        </p>
                        <p><span className="right">订单整体折扣：%<Input value={discountRate} style={{width: 100}}
                                                                        type='number'
                                                                        disabled={this.userData.second}
                                                                        onChange={this.countChange}/></span></p>
                        <p><span className="right">实收总额：￥<Input
                            value={disActualAmount}
                            style={{width: 100}}
                            type='number'
                            onChange={this.disActualAmountChange}/></span></p>
                    </div>
                </div>

            </div>

            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.handleOk}
                okText="关闭窗口"
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1300}
                style={{top: 20}}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={6}><label>物料名称：</label><Input style={{width: 200}} value={this.state.name}
                                                                         onChange={this.nameChange}
                                                                         onKeyPress={this.keypress}/></Col>
                            <Col span={6}><label>物料编码：</label><Input style={{width: 200}} value={this.state.code}
                                                                         onChange={this.codeChange}
                                                                         onKeyPress={this.keypress}/></Col>
                            <Col span={4}><label>是否退市：</label><Select style={{width: 100}} value={this.state.sfts}
                                                                          onChange={this.sftsChange} defaultValue="">
                                <Select.Option value="">全部</Select.Option>
                                <Select.Option value="1">是</Select.Option>
                                <Select.Option value="0">否</Select.Option>
                            </Select></Col>
                            <Col span={4}><Checkbox onChange={this.kcspChange}
                                                    checked={kcsp_checked}>库存商品</Checkbox></Col>
                            <Col span={4}><Button onClick={this.getAddArray} loading={addLoading}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                </div>
            </Modal>

            <Modal visible={quickVisible}
                   title={'快捷录入'}
                   onOk={this.handleOk6}
                   onCancel={this.handleCancel6}
                   confirmLoading={quickLoading}
                   maskClosable={false} width={500}
            >
                <div><TextArea rows={10} placeholder='按[物料编码，数量]格式录入，多个换行录入' value={quickString}
                               onChange={this.quickChange}></TextArea></div>
            </Modal>

        </div>
    }
}

export default withRouter(CustomOrderAdd);



// WEBPACK FOOTER //
// ./src/routes/thingsOrder/add.js